import { useQuery } from '@tanstack/react-query';
import { gaeb, controlling } from '@/utils/api';

export function useGaebProjects() {
  return useQuery({
    queryKey: ['gaeb', 'projects'],
    queryFn: () => gaeb.getProjects().then((r) => r.data),
  });
}

export function useGaebProject(id: number | string | undefined) {
  return useQuery({
    queryKey: ['gaeb', 'projects', id],
    queryFn: () => gaeb.getProject(id).then((r) => r.data),
    enabled: !!id,
  });
}

export function useGaebPositions(projectId: number | string | undefined) {
  return useQuery({
    queryKey: ['gaeb', 'positions', projectId],
    queryFn: () => gaeb.getPositions(projectId).then((r) => r.data),
    enabled: !!projectId,
  });
}

export function useDatanormStatus() {
  return useQuery({
    queryKey: ['gaeb', 'datanorm', 'status'],
    queryFn: () => gaeb.getDatanormStatus().then((r) => r.data),
  });
}

export function useGaebMappings(params?: Record<string, any>) {
  return useQuery({
    queryKey: ['gaeb', 'mappings', params],
    queryFn: () => gaeb.getMappings(params).then((r) => r.data),
  });
}

export function useControllingBudgets() {
  return useQuery({
    queryKey: ['controlling', 'budgets'],
    queryFn: () => controlling.listBudgets().then((r) => r.data),
  });
}

export function useControllingDashboard(budgetId: number | string | undefined) {
  return useQuery({
    queryKey: ['controlling', 'dashboard', budgetId],
    queryFn: () => controlling.getDashboard(budgetId).then((r) => r.data),
    enabled: !!budgetId,
  });
}
